import { useQuery } from '@tanstack/react-query';
import { getFeaturebaseToken } from 'shared/services/backend-api';

export const queryKey = 'featurebase-token';

export const useFeaturebaseTokenQuery = () =>
  useQuery({
    queryKey: [queryKey],
    queryFn: getFeaturebaseToken,
    enabled: false,
    staleTime: 5 * 60 * 1000,
    placeholderData: { token: '' },
  });
